export interface UrlAccessCategory {
  id: string;
  name: string;
  description?: string;
  urls: string[];
}

/** 크롬북·디벗 등 학교 기기 URL 허용 목록 (항목별 분류) */
export const DEVICE_WHITELIST_CATEGORIES: UrlAccessCategory[] = [
  {
    id: 'chrome-system',
    name: '크롬 OS · 시스템',
    description: '크롬북 기본 동작에 필요한 시스템·확장 프로그램 URL',
    urls: [
      'devtools://*',
      'blob://*',
      'data://*',
      'filesystem://*',
      'chrome://resources/*',
      'chrome-error://*',
      'chrome-untrusted://*',
      'file://*',
      'chrome://new-tab-page/',
      'chrome://new-tab-page-third-party',
      'chrome-extension://ecnphgnkegcppnphcaiduncllbfehebf/',
      'chrome-extension://ecnphgnkegcppnphcaiduncllbfehebf/*',
      'chrome-error://chromewebdata/',
      'chrome://file-manager',
      'chrome://gallery',
      'chrome://media-app',
      'chrome://camera',
      'chrome://settings',
      'chrome://os-settings',
      'chrome://*'
    ]
  },
  {
    id: 'google',
    name: 'Google',
    description: '검색, 계정, 클래스룸, 문서, 사이트 등 Google 서비스',
    urls: [
      'clients2.google.com',
      'clients2.googleusercontent.com',
      'update.googleapis.com',
      'drive.google.com',
      'www.google.co.kr/*',
      'https://www.google.com',
      'www.google.com',
      'google.com',
      'www.google.com/*',
      'https://accounts.google.co.kr/',
      'classroom.google.com/',
      'gds.google.com',
      'myaccount.google.com',
      'https://accounts.google.com/',
      'gmail.com',
      'https://docs.google.com/forms',
      'https://docs.google.com',
      'https://sites.google.com/',
      'https://gstatic.com',
      'https://googleusercontent.com',
      'https://lh3.googleusercontent.com/',
      'https://fonts.gstatic.com/',
      'https://play.google.com/',
      'https://www.gstatic.com/',
      'https://script.google.com/a/macros/yonggang.sen.ms.kr/s/AKfycbw0eU_FNB5ZLzxJqO3hi5F_YiTM27t5Sl-EwYYNEnCOabtcIbzyyIGiz5hy6VALscYF/exec',
      'https://sites.google.com/yonggang.sen.ms.kr/hanmun/'
    ]
  },
  {
    id: 'microsoft',
    name: 'Microsoft · Teams · Office 365',
    description: 'Teams, Office, 로그인, SharePoint 등 Microsoft 서비스',
    urls: [
      'teams.microsoft.com/',
      'teams.microsoft.com/*',
      'https://teams.cloud.microsoft',
      'https://teams.cloud.microsoft/*',
      'login.microsoft.com/',
      'https://login.live.com',
      'https://login.live.com/',
      'com.microsoft.copilot',
      'https://copilot.microsoft.com/',
      'microsoft.com',
      'com.microsoft.Office.Excel',
      'https://login.microsoftonline.com/',
      'https://statics.teams.cdn.office.net/',
      'https://res.cdn.office.net/',
      'https://res-1.cdn.office.net/',
      'https://browser.events.data.microsoft.com',
      'https://config.teams.microsoft.com/',
      'https://substrate.office.com/',
      'https://sen0842-my.sharepoint.com',
      'https://sen0842.sharepoint.com/',
      'https://assignments.edu.cloud.microsoft/',
      'https://assignments.edu.cloud.microsoft/*',
      'https://lync.com',
      'office.com',
      'office365.com',
      'api.teams.cloud.microsoft',
      'wss://augloop.office.com/',
      'wss://substrate.office.com',
      'wss://test.augloop.svc.cloud.dev.microsoft',
      'wss://int.augloop.svc.cloud.dev.microsoft',
      'https://kr-prod.asyncgw.teams.microsoft.com/',
      'https://reflect.edu.cloud.microsoft',
      'https://krc-word-view.officeapps.live.com/',
      'https://krc-word-edit.officeapps.live.com/',
      'https://res.public.onecdn.static.microsoft/',
      'https://word-telemetry.officeapps.live.com/',
      'https://graph.microsoft.com/',
      'https://m365.cloud.microsoft/',
      'https://word.cloud.microsoft/',
      'https://powerpoint.cloud.microsoft/',
      'https://common.online.office.com/',
      'https://wise-m.public.cdn.office.net/',
      'https://us-mobile.events.data.microsoft.com/',
      'wss://msit.augloop.svc.cloud.microsoft',
      'wss://augloop.svc.cloud.microsoft',
      'wss://gcc.augloop.svc.cloud.microsoft',
      'www.yammer.com',
      'https://webshell.suite.office.com',
      'https://browser.pipe.aria.microsoft.com/',
      'https://messaging.engagement.office.com/',
      'https://forms.cloud.microsoft/'
    ]
  },
  {
    id: 'education-office',
    name: '교육청 · 교육부',
    description: '서울교육청, 교육부, 에듀테크 포털 등',
    urls: [
      'https://www.sen.go.kr/',
      'https://www.moe.go.kr/',
      'https://cbt.sen.go.kr/',
      'https://senedu.kr',
      'http://senedu.kr',
      'https://auth.senedu.kr',
      'https://auth.senedu.kr/',
      'https://auyh.senedu.kr',
      'https://oauth2client.i-screammedia.com/',
      'http://www.xn--s39aj90b0nb2xw6xh.kr/'
    ]
  },
  {
    id: 'maru',
    name: 'MARU (마루)',
    description: '마루 플랫폼 및 Firebase 호스팅',
    urls: [
      'http://maruedu.kr/login',
      'http://maruedu.kr/class/',
      'http://maruedu.kr/',
      'https://maruedu.kr/',
      'leadlearn-ccf50.firebaseapp.com',
      'https://leadlearn-ccf50.web.app',
      'https://leadlearn-ccf50.firebaseapp.com/',
      'https://console.firebase.google.com/?hl=ko',
      'https://firestore.googleapis.com/'
    ]
  },
  {
    id: 'coding',
    name: '코딩 · 메이커 교육',
    description: 'MakeCode, Tinkercad, App Inventor, GitHub 등',
    urls: [
      'arcade.makecode.com/',
      'https://makecode.microbit.org/',
      'https://makecode.com',
      'https://cdn.makecode.com/',
      'microbit.org',
      'https://trg-arcade.userpxt.io',
      'www.tinkercad.com',
      'static.tinkercad.com',
      'https://www.tinkercad.com/',
      'https://accounts.autodesk.com/',
      'http://accounts.autodesk.com/',
      'https://api-reader-prd.tinkercad.com/',
      'https://api-reader-prd.tinkercad.com/users',
      'https://events.launchdarkly.com/',
      'https://www.recaptcha.net/',
      'https://editor.tinkercad.com/',
      'https://kidsafe.com/',
      'https://static.tinkercad.com/',
      'https://developer.api.autodesk.com/',
      'https://idp.auth.autodesk.com/',
      'https://signin.autodesk.com/',
      'editor.tinkercad.com',
      'api.launchdarkly.com',
      'www.autodesk.com',
      'www.autodesk.com/kr/',
      'appinventor.mit.edu',
      'ai2/appinventor.mit.edu',
      'https://github.com/'
    ]
  },
  {
    id: 'quiz-game',
    name: '학습 게임 · 퀴즈',
    description: 'Blooket, Gimkit, Kahoot, ZEP, 클래스카드 등',
    urls: [
      'play.blooket.com/',
      'blooket.com/',
      'https://www.gimkit.com/',
      'https://quiz.zep.us/',
      'https://zep.us/play/',
      'game.raporapo.com',
      'raporapo.com',
      'play.raporapo.com',
      'https://samquiz.net/',
      'https://www.menti.com/',
      'https://kahoot.it/',
      'https://quizn.show/*',
      'https://www.classcard.net/',
      'https://b.classcard.net/'
    ]
  },
  {
    id: 'content-tools',
    name: '수업 도구 · 콘텐츠 제작',
    description: 'Canva, Notion, Padlet, Book Creator, ClassroomScreen 등',
    urls: [
      'www.canva.com/',
      'canva.link/',
      'https://export-download.canva.com/',
      'https://yonggang.my.canva.site/',
      'notion.so',
      'https://www.notion.com/',
      'https://elite-lilac-5c5.notion.site/',
      'app.bookcreator.com/',
      'padlet.com',
      'https://v1.padlet.pics/',
      'https://classroomscreen.com/'
    ]
  },
  {
    id: 'learning-content',
    name: '교과 · 학습 콘텐츠',
    description: 'Amplify, Desmos, 두클래스, EBS, 지학사 등',
    urls: [
      'https://my.amplify.com/',
      'https://learning.amplify.com/home/educator/',
      'https://learning.amplify.com/',
      'https://www.desmos.com/?lang=ko',
      'https://file.douclass.com/c2/sci/mi-sci2/interani/i-ch112/index.html',
      'https://javalab.org/ko/',
      'https://www.ebsmath.co.kr/*',
      'https://www.jihak.co.kr/*',
      'https://jeong-sssol.github.io/history-master/'
    ]
  },
  {
    id: 'other-edu',
    name: '기타 교육 서비스',
    description: '태권벨, 웨일스페이스, 피쿠 등',
    urls: [
      'www.tkbell.co.kr',
      'https://tkbell.kr',
      'http://tkbell.kr/',
      'https://q.tkbell.co.kr/',
      'https://q1.tkbell.co.kr',
      'https://q.tkbell.kr',
      'https://b.tkbell.kr',
      'https://b.tkbell.co.kr',
      'download.tkbell.co.kr',
      'https://ubt.whalespace.io',
      'https://authn.whalespace.io',
      'https://auth.worksmobile.com',
      'https://www.piku.co.kr/w/7zd4dE'
    ]
  },
  {
    id: 'kami',
    name: 'Kami · 결제 연동',
    description: 'Kami 앱 및 Stripe 결제 연동',
    urls: [
      'https://www.kamiapp.com/',
      'https://web.kamihq.com/',
      'https://api.kamihq.com/',
      'https://js.stripe.com/',
      'https://m.stripe.network/inner.html'
    ]
  },
  {
    id: 'naver',
    name: '네이버 · 국내 포털',
    description: '네이버 사전, 포털 등',
    urls: [
      'https://hanja.dict.naver.com/',
      'https://ko.dict.naver.com/',
      'https://ko.dict.naver.com/#/main',
      'https://hanja.dict.naver.com/#/main',
      'https://www.naver.com/'
    ]
  },
  {
    id: 'misc',
    name: '기타',
    description: 'Netlify, Pinterest 등 기타 허용 URL',
    urls: [
      'https://www.netlify.com',
      'https://bespoke-liger-db4c7f.netlify.app/',
      'https://kr.pinterest.com/',
      'https://privacycg.github.io/'
    ]
  }
];

/** 전체 화이트리스트 (한 줄에 하나씩 관리자 콘솔 붙여넣기용) */
export const DEVICE_WHITELIST_URLS: string[] = DEVICE_WHITELIST_CATEGORIES.flatMap((category) => category.urls);

export interface UrlAccessBlacklistCategory extends UrlAccessCategory {}

/** 학교 기준에 맞게 차단할 URL (필요 시 항목 추가) */
export const DEVICE_BLACKLIST_CATEGORIES: UrlAccessBlacklistCategory[] = [];

export const DEVICE_BLACKLIST_URLS: string[] = DEVICE_BLACKLIST_CATEGORIES.flatMap((category) => category.urls);
